export default "__VITE_ASSET__CtX$09hD__"